import { requestAction } from './cef';

// Logs a timed step both to the devtools console and to the native launcher.log
// (via BENCH_LOG), so a full launch breakdown survives across sessions.
export function bench(label: string, ms: number): void {
  const msg = `${label}: ${Math.round(ms)}ms`;
  console.log('[BENCH] ' + msg);
  try {
    requestAction('BENCH_LOG', { msg });
  } catch (e) {
    // ignore
  }
}
